import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue } from 'bootstrap-vue'

import store from '@/store'
import router from '@/router'
// import Home from './components/pages/Home'
// import ShoppingCard from './components/pages/ShoppingCard'
// import Category from '@/views/Category/Category'



Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './style.scss'

import axios from 'axios'

axios.defaults.baseURL = 'https://offers-jo.easysooq.net/admin/ajax_requests.php'
Vue.use(axios)
//font awsome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSearch, faShoppingCart, faCheck, faShoppingBasket, faTimes, faLock, faTrash, faPlus, faMinus} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font', FontAwesomeIcon)

library.add(faSearch, faShoppingCart, faCheck, faShoppingBasket, faTimes, faLock, faTrash, faPlus, faMinus)

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
